// Put on every page by vite.config.mjs (staleChunkReloadOnEveryPage).
import { installStaleChunkReload } from './utils/staleChunkReload';

installStaleChunkReload();
